export default {"src":"/_next/static/media/Line 53.278896b8.svg","height":7,"width":351,"blurWidth":0,"blurHeight":0};